import assetPath from '/app/xinglets/lebenslauf/components/frame/src/assets/favicon.ico';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')